import React, { useEffect } from "react";
import { Box, Container, CssBaseline, Grid } from "@mui/material";
import { Navigate, Outlet, useMatch } from "react-router-dom";

import { appPrefix, appDefaultRoute } from "pages/app-taxi-ranking";
import { useSelector } from "react-redux";
import { LoadingWrapper } from "components/wrappers/LoadingWrapper";
import { useAppDispatch } from "store";
import { setRootPath } from "reducers/auth.reducer";
import { toggleReportLoading } from "reducers/report.reducer";
import NavbarTaxiRank from "./header/NavbarTaxiRank";
import SidebarReports from "./drawer/SidebarReports";

export default function ReportsLayout() {
    const match = useMatch(appPrefix);
    const { isReportsLoading } = useSelector((state) => state.report);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setRootPath("/taxi-ranking/reports"));
        dispatch(toggleReportLoading(true))
    }, []);

    if (match) {
        return <Navigate to={appDefaultRoute} replace />;
    }

    return (
        <Container maxWidth="xl" disableGutters>
            <CssBaseline />
            <NavbarTaxiRank />
            <Grid className="custom-container">
                <SidebarReports rootPath="/taxi-ranking/reports" />

                <div className="content">
                    {!isReportsLoading  ? (
                        <Outlet />
                    ) : (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
                            <LoadingWrapper isLoading />
                        </Box>
                    )}
                </div>
            </Grid>
        </Container>
    );
}
